import {
  GROUP_PERMISSIONS_LIST,
  GROUP_PERMISSIONS_LIST_SUCCESS,
  GROUP_PERMISSIONS_LIST_ERROR,
  GROUP_PERMISSIONS_NEW,
  GROUP_PERMISSIONS_NEW_SUCCESS,
  GROUP_PERMISSIONS_NEW_ERROR,
  GROUP_PERMISSIONS_EDIT,
  GROUP_PERMISSIONS_DELETE,
  GROUP_PERMISSIONS_DELETE_SUCCESS,
  GROUP_PERMISSIONS_DELETE_ERROR,
  GROUP_PERMISSIONS_TYPES_LIST,
  GROUP_PERMISSIONS_TYPES_LIST_SUCCESS,
  GROUP_PERMISSIONS_TYPES_LIST_ERROR,
} from "./actionTypes"

const initialState = {
  responseList: "",
  loadingList: false,
  errorList: "",
  responseNew: "",
  loadingNew: false,
  errorNew: "",
  responseDelete: "",
  loadingDelete: false,
  errorDelete: "",
  responseTypesList: "",
  loadingTypesList: false,
  errorTypesList: "",
}

const GroupPermissions = (state = initialState, action) => {
  switch (action.type) {
    case GROUP_PERMISSIONS_LIST:
      state = {
        ...state,
        loadingList: true,
        errorList: "",
      }
      break
    case GROUP_PERMISSIONS_LIST_SUCCESS:
      state = {
        ...state,
        loadingList: false,
        responseList: action.payload.data
      }
      break
    case GROUP_PERMISSIONS_LIST_ERROR:
      state = {
        ...state,
        loadingList: false,
        errorList: action.payload
      }
      break
    case GROUP_PERMISSIONS_NEW:
      state = {
        ...state,
        loadingNew: true,
        responseNew: "",
        errorNew: ""
      }
      break
    case GROUP_PERMISSIONS_NEW_SUCCESS:
      state = {
        ...state,
        loadingNew: false,
        responseNew: action.payload.data
      }
      break
    case GROUP_PERMISSIONS_NEW_ERROR:
      state = {
        ...state,
        loadingNew: false,
        errorNew: action.payload
      }
      break
    case GROUP_PERMISSIONS_EDIT:
      state = {
        ...state,
        loadingNew: true,
        responseNew: "",
        errorNew: ""
      }
      break
    case GROUP_PERMISSIONS_DELETE:
      state = {
        ...state,
        loadingDelete: true,
        responseDelete: "",
        errorDelete: ""
      }
      break
    case GROUP_PERMISSIONS_DELETE_SUCCESS:
      state = {
        ...state,
        loadingDelete: false,
        responseDelete: action.payload.data
      }
      break
    case GROUP_PERMISSIONS_DELETE_ERROR:
      state = {
        ...state,
        loadingDelete: false,
        errorDelete: action.payload
      }
      break
    case GROUP_PERMISSIONS_TYPES_LIST:
      state = {
        ...state,
        loadingTypesList: true,
        responseTypesList: "",
        responseNew: "",
        errorTypesList: "",
        errorNew: "",
        errorEdit: "",
      }
      break
    case GROUP_PERMISSIONS_TYPES_LIST_SUCCESS:
      state = {
        ...state,
        loadingTypesList: false,
        responseTypesList: action.payload.data
      }
      break
    case GROUP_PERMISSIONS_TYPES_LIST_ERROR:
      state = {
        ...state,
        loadingTypesList: false,
        errorTypesList: action.payload
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default GroupPermissions
